import { Reveal } from "./motion";

const steps = [
  {
    n: "01",
    body: "You rent the truck, container, or trailer.",
  },
  {
    n: "02",
    body: "Our crew loads, unloads, and handles the heavy lifting.",
  },
  {
    n: "03",
    body: "You pay only for labor, often less than full-service movers.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="relative z-10 bg-[#262626] py-20 sm:py-28 border-b border-white/5"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl mb-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          How Labor-Only Works
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl">
          Simple, flexible, affordable
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              data-testid={`how-step-${s.n}`}
              className="h-full border border-[#3d3d3d] bg-[#303030] p-8"
            >
              <span className="font-display font-extrabold text-4xl text-[#FF4500] leading-none">
                {s.n}
              </span>
              <p className="mt-5 text-neutral-200 text-base sm:text-lg leading-relaxed">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
